import { css } from 'styled-components';
export const disabledLinkEffect = () => css `
  pointer-events: none;
  opacity: 0.4;
`;
//# sourceMappingURL=disabledLinkEffect.js.map